<template>
  <el-dialog :title="editDepart? (departmentForm.id ? '编辑科室' : '新增科室') : '查看科室详情'" width="560px" :visible="true"
    :close-on-click-modal="false" :before-close="handleClose">
    <div v-if="editDepart">
      <el-form ref="departmentFormRef" :model="departmentForm" :rules="departmentFormRules" label-width="150px"
        label-position="right">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="归属类别：" required>
              <el-radio-group v-model="departmentForm.category" :disabled="departmentForm.id ? true : false"
                @change="selectCategory">
                <el-radio :label="1" v-if="userPlatForm=='platForm'">互医机构</el-radio>
                <el-radio :label="2" v-if="userPlatForm=='organization'">线下机构</el-radio>
                <el-radio :label="3" v-if="userPlatForm=='platForm'">标准科室</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 互医机构 -->
        <div v-if="departmentForm.category == 1">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="互医机构：" prop="platformId">
                <el-select v-model="departmentForm.platformId" :disabled="departmentForm.id ? true : false"
                  style="width:100%" clearable filterable size="medium" placeholder="请输入关键词搜索互医机构">
                  <el-option v-for="item in platFormList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="标准一级科室：" prop="standardLevel1">
                <el-select v-model="departmentForm.standardLevel1" style="width:100%" clearable filterable size="medium"
                  placeholder="请输入关键词搜索标准一级科室" @change="getSecondDepartmentList">
                  <el-option v-for="item in firstDepartmentList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="departmentForm.standardLevel1 && secondDepartmentList.length" :gutter="20">
            <el-col :span="24">
              <el-form-item label="标准二级科室：" prop="standardLevel2">
                <el-select v-model="departmentForm.standardLevel2" style="width:100%" clearable filterable size="medium"
                  placeholder="请输入关键词搜索标准二级科室">
                  <el-option v-for="item in secondDepartmentList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="是否置顶：" prop="top">
                <el-radio-group v-model="departmentForm.top">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="科室简介：" prop="description">
                <el-input type="textarea" clearable :rows="2" placeholder="请输入科室介绍"
                  v-model="departmentForm.description">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 线下医院 -->
        <div v-if="departmentForm.category == 2">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="科室名称：" prop="name">
                <el-input v-model="departmentForm.name" clearable placeholder="请输入科室名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="归属线下医院：" prop="hospitalId">
                  <el-select v-model="departmentForm.hospitalId" :disabled="departmentForm.id && departmentForm.hospitalId ? true : false" style="width:100%" filterable size="medium" placeholder="请输入关键词搜索归属线下医院" @change="getFirstDepartmentList">
                    <el-option
                      v-for="item in hospitalList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="线下机构：" prop="offlineInstitutions">
                <el-input v-model="departmentForm.offlineInstitutions" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="是否置顶：" prop="top">
                <el-radio-group v-model="departmentForm.top">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="科室级别：" prop="level">
                <el-radio-group v-model="departmentForm.level" :disabled="departmentForm.id && levelVal ? true : false"
                  @change="selectDepartLevelOrg">
                  <el-radio :label="1">一级科室</el-radio>
                  <el-radio :label="2">二级科室</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="departmentForm.level == 1" :gutter="20">
            <el-col :span="24">
              <el-form-item label="对应标准科室：" prop="platformLevel1">
                <el-select v-model="departmentForm.platformLevel1" style="width:100%" clearable filterable size="medium"
                  placeholder="请输入关键词搜索对应标准科室">
                  <el-option v-for="item in firstDepartmentList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="departmentForm.level == 2" :gutter="20">
            <el-col :span="24">
              <el-form-item label="归属一级科室：" prop="parentId">
                <el-select v-model="departmentForm.parentId" style="width:100%" clearable filterable size="medium"
                  placeholder="请输入关键词搜归属一级科室" @change="getInstitutionalDepartment">
                  <el-option v-for="item in firstDepartmentList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="departmentForm.level == 2" :gutter="20">
            <el-col :span="24">
              <el-form-item label="对应标准科室：" prop="platformLevel2">
                <el-select v-model="departmentForm.platformLevel2" style="width:100%" clearable filterable size="medium"
                  placeholder="请输入关键词搜索对应标准科室">
                  <el-option v-for="item in secondDepartmentList" :key="item.id" :label="item.standardDepartmentName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="科室简介：" prop="description">
                <el-input type="textarea" clearable :rows="2" placeholder="请输入科室介绍"
                  v-model="departmentForm.description">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 标准科室 -->
        <div v-if="departmentForm.category == 3">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="科室名称：" prop="name">
                <el-input v-model="departmentForm.name" clearable placeholder="请输入科室名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="科室级别：" prop="level">
                <el-radio-group v-model="departmentForm.level"
                  :disabled="departmentForm.id && departmentForm.level ? true : false" @change="selectDepartLevel">
                  <el-radio :label="1">一级科室</el-radio>
                  <el-radio :label="2">二级科室</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="departmentForm.level == 2" :gutter="20">
            <el-col :span="24">
              <el-form-item label="归属一级科室：" prop="parentId">
                <el-select v-model="departmentForm.parentId" style="width:100%" clearable filterable size="medium"
                  placeholder="请输入关键词搜归属一级科室">
                  <el-option v-for="item in firstDepartmentList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>

    <div v-if="!editDepart">
      <!-- 互医机构 -->
      <el-form v-if="departmentForm.category == 1" label-width="150px" label-position="right">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="归属类别：">
              <span>互医机构</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="互医机构：">
              <span>{{departmentForm.platformName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="标准一级科室：">
              <span>{{departmentForm.standardNameLevel1}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="标准二级科室：">
              <span>{{departmentForm.standardNameLevel2}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="userPlatForm!='organization'">
          <el-col :span="24">
            <el-form-item label="是否置顶：">
              <span>{{departmentForm.top ? '是' : '否'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" class="plat-style">
            <el-form-item label="科室简介：">
              <span>{{departmentForm.description}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 查看线下医院 -->
      <el-form v-if="departmentForm.category == 2" label-width="150px" label-position="right">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="归属类别：">
              <span>线下机构</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="科室名称：">
              <span>{{departmentForm.name}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="线下机构：">
              <span>{{departmentForm.hospitalName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="是否置顶：">
                <span>{{departmentForm.top ? '是' : '否'}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="科室级别：">
              <span>{{ departmentForm.level === 1 ? '一级科室' : departmentForm.level === 2 ? '二级科室' : '' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="departmentForm.level == 2" :gutter="20">
          <el-col :span="24">
            <el-form-item label="归属一级科室：">
              <span>{{departmentForm.parentName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="对应标准科室：">
              <span v-if="departmentForm.level == 1">{{departmentForm.standardNameLevel1}}</span>
              <span v-if="departmentForm.level == 2">{{departmentForm.standardNameLevel2}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="科室简介：" class="plat-style">
              <span>{{departmentForm.description}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 查看标准科室 -->
      <el-form v-if="departmentForm.category == 3" label-width="250px" label-position="right">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="归属类别：">
              <span>标准科室</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="科室名称：">
              <span>{{departmentForm.name}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="科室级别：">
              <span>{{ departmentForm.level === 1 ? '一级科室' : departmentForm.level === 2 ? '二级科室' : '' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="departmentForm.level == 2" :gutter="20">
          <el-col :span="24">
            <el-form-item label="归属一级科室：">
              <span>{{departmentForm.parentName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="!editDepart&&isCancelShow" slot="footer" style="text-align:center">
      <el-button size="small" type="primary" style="width:110px" @click="handleToEdit">去编辑</el-button>
    </div>
    <div v-if="editDepart" slot="footer" style="text-align:center">
      <el-button size="small" style="width:110px" @click="handleReset">重置</el-button>
      <el-button size="small" type="primary" style="width:110px" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { DEEP_CLONE } from "@/utils/constants";
import {
  queryPlatformList,
  selectDepartmentLevel,
  addPlatDepartment,
  updatePlatDepartment,
  addOpenDepartment,
  updateOpenDepartment,
  addStandardDepartment,
  updateStandardDepartment,
  queryHospitalList,
  queryOpenDepartmentList,
  institutionalDepartment
} from "@/api/departmentManage";

export default {
  props: {
    departmentForm: {
      type: Object
    },
    showDialog: {
      type: Boolean
    },
    editDepart: {
      type: Boolean
    },
    isCancelShow:{
      type: Boolean
    }
    // selectRow: {
    //   type: Object
    // }
  },
  components: {},
  data() {
    return {
      hospitalList: [],
      platFormList: [],
      firstDepartmentList: [],
      secondDepartmentList: [],
      // departmentForm: {
      //   platformId: '',
      //   standardLevel1: '',
      //   standardLevel2: ''
      // },

      // input: '',
      // radio: 9,
      // editDepart: false,
      // textarea: '',
      // radio1: 6
      departmentFormRules: {
        // imageUrlRes:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur']}],
        category: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        platformId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        standardLevel1: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        standardLevel2: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        description: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          },
          {
            min: 5,
            max: 200,
            message: "长度在 5 到 200 个字符",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          },
          { min: 1, max: 15, message: "长度在 1 到 15 个字符", trigger: "blur" }
        ],
        top: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        level: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        platformLevel1: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        platformLevel2: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        offlineInstitutions: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        parentId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ]
      },
      levelVal: 0,
      userPlatForm: "platForm",
      isEditShow:true,
      platformType:"1"
    };
  },
  async created() {
    
    this.levelVal = DEEP_CLONE(this.departmentForm).level;
    await this.getInitList();
    await this.getFirstDepartmentList();
    if (this.departmentForm.category === 2 && this.departmentForm.level === 1) {
      this.getFirstDepartmentListOrg(this.departmentForm.parentId, 1);
    }
    if (this.departmentForm.category === 2 && this.departmentForm.level === 2) {
      this.getInstitutionalDepartment(this.departmentForm.parentId, 1);
    }
    if (
      this.departmentForm.category === 1 &&
      this.departmentForm.standardLevel1
    ) {
      this.getSecondDepartmentList(this.departmentForm.standardLevel1, 1);
    }
  },
  mounted() {
    this.userPlatForm = this.$store.state.userPlatForm;
    this.departmentForm.offlineInstitutions = this.$store.state.orgName;
  },
  methods: {
    async selectDepartLevel(val) {
      // this.firstDepartmentList = []
      this.secondDepartmentList = [];
      this.departmentForm.standardLevel1 = "";
      this.departmentForm.standardLevel2 = "";
      this.departmentForm.parentId = "";
      await this.getFirstDepartmentList();
    },
    async selectDepartLevelOrg(){
        this.secondDepartmentList = [];
        this.departmentForm.parentId = "";
        this.departmentForm.standardLevel1 = "";
        this.departmentForm.standardLevel2 = "";
        await this.getFirstDepartmentListOrg();
    },
    selectCategory(val) {
      this.departmentForm.category = val;
      this.$refs.departmentFormRef.resetFields();
      this.departmentForm.parentId = "";
      this.departmentForm.category = val;
    },
    //
    async getInitList() {
      let res = await queryPlatformList({
        keyword: "",
        disabled: false
      });
      if (res.code === 0) {
        this.platFormList = res.data;
      }
      let res1 = await queryHospitalList({
        keyword: "",
        disabled: false
      });
      if (res1.code === 0) {
        this.hospitalList = res1.data;
      }
    },
    //
    async getFirstDepartmentList() {
      this.firstDepartmentList = [];
      if (
        this.departmentForm.category === 2 &&
        this.departmentForm.level === 2 &&
        !this.departmentForm.id
      ) {
        this.departmentForm.parentId = "";
        this.departmentForm.standardLevel2 = "";
      }
      if (
        this.departmentForm.category === 2 &&
        this.departmentForm.level === 2
      ) {
        // this.departmentForm.parentId = ''
        // this.departmentForm.standardLevel2 = ''
        if (!this.departmentForm.hospitalId) {
          return;
        }
        // 线下医院
        let res = await queryOpenDepartmentList({
          parentId: 0,
          disabled: false,
          hospitalId: this.departmentForm.hospitalId
        });
        if (res.code === 0) {
          this.firstDepartmentList = res.data;
        }
      } else {
        let res = await selectDepartmentLevel({
          parentId: 0,
          disabled: false
        });
        if (res.code === 0) {
          this.firstDepartmentList = res.data;
        }
      }
    },
     async getFirstDepartmentListOrg() {
      this.firstDepartmentList = [];
      if (
        this.departmentForm.category === 2 &&
        this.departmentForm.level === 2 &&
        !this.departmentForm.id
      ) {
        this.departmentForm.parentId = "";
        this.departmentForm.standardLevel2 = "";
      }
      if (
        this.departmentForm.category === 2 &&
        this.departmentForm.level === 2
      ) {
        // this.departmentForm.parentId = ''
        // this.departmentForm.standardLevel2 = ''
        // if (!this.departmentForm.hospitalId) {
        //   return;
        // }
        // 线下医院
        let res = await queryOpenDepartmentList({
          parentId: 0,
          disabled: false,
          hospitalId: this.departmentForm.hospitalId
        });
        if (res.code === 0) {
          this.firstDepartmentList = res.data;
        }
      } else {
        let res = await institutionalDepartment({
          parentId: 0,
          disabled: false
        });
        if (res.code === 0) {
          this.firstDepartmentList = res.data;
        }
      }
    },
    async getSecondDepartmentList(val, mark) {
      let selectId;
      selectId = val;
      if (!mark) {
        this.departmentForm.standardLevel2 = "";
      }
      if (this.departmentForm.category === 2) {
        selectId = this.firstDepartmentList.filter(v => v.id === val)[0]
          .standardDepartmentId;
      }
      this.secondDepartmentList = [];
      let res = await selectDepartmentLevel({
        parentId: selectId,
        disabled: false
      });
      if (res.code === 0) {
        this.secondDepartmentList = res.data;
      }
    },
    //获取机构科室
    async getInstitutionalDepartment(val,mark) {
      let selectId;
     selectId = val;
      if (!mark) {
        this.departmentForm.standardLevel2 = "";
        if(this.departmentForm.platformLevel2){
         this.departmentForm.platformLevel2=""
        }
      }
     
      if (this.departmentForm.category === 2) {
        selectId = this.firstDepartmentList.filter(v => v.id === val)[0]
          .platformLevel1;
      }
      this.secondDepartmentList = [];
      let res = await institutionalDepartment({
        parentId: selectId,
        disabled: false
      });
      if (res.code === 0) {
        this.secondDepartmentList = res.data;
      }
    },
    // 重置
    handleReset() {
      this.$emit("resetObj");
    },
    // 保存
    async handleSave() {
      let valRes;
      this.$refs.departmentFormRef.validate(val => {
        valRes = val;
      });
      if (!valRes) {
        return;
      }
      if (this.departmentForm.category === 1) {
        // 修改
        if (this.departmentForm.id) {
          delete this.departmentForm.createTime;
          delete this.departmentForm.createUserId;
          delete this.departmentForm.deleted;
          delete this.departmentForm.updateTime;
          delete this.departmentForm.updateUserId;
          let res = await updatePlatDepartment(this.departmentForm);
          if (res.code === 0) {
            this.$message.success("当前科室信息已修改成功");
            this.$emit("update:showDialog", false);
            this.$parent.getTableList(1);
          }
        } else {
          let res = await addPlatDepartment(this.departmentForm);
          if (res.code === 0) {
            this.$message.success("当前科室信息已保存成功");
            this.$emit("update:showDialog", false);
            this.$parent.getTableList(1);
          }
        }
      }
      if (this.departmentForm.category === 2) {
        // 修改
        if (this.departmentForm.id) {
          delete this.departmentForm.createTime;
          delete this.departmentForm.createUserId;
          delete this.departmentForm.deleted;
          delete this.departmentForm.updateTime;
          delete this.departmentForm.updateUserId;
          let res = await updateOpenDepartment(this.departmentForm);
          if (res.code === 0) {
            this.$message.success("当前科室信息已修改成功");
            this.$emit("update:showDialog", false);
            this.$parent.getTableList(1);
          }
        } else {
          let res = await addOpenDepartment(this.departmentForm);
          if (res.code === 0) {
            this.$message.success("当前科室信息已保存成功");
            this.$emit("update:showDialog", false);
            this.$parent.getTableList(1);
          }
        }
      }
      if (this.departmentForm.category === 3) {
        // 修改
        if (this.departmentForm.id) {
          let res = await updateStandardDepartment(this.departmentForm);
          if (res.code === 0) {
            this.$message.success("当前科室信息已修改成功");
            this.$emit("update:showDialog", false);
            this.$parent.getTableList(1);
          }
        } else {
          let res = await addStandardDepartment(this.departmentForm);
          if (res.code === 0) {
            this.$message.success("当前科室信息已保存成功");
            this.$emit("update:showDialog", false);
            this.$parent.getTableList(1);
          }
        }
      }
    },
    handleToEdit() {
      // this.editDepart = true
      this.$parent.changeEditStatus();
    },

    handleClose() {
      this.$emit("update:showDialog", false);
    }
  }
};
</script>
<style lang="less" scoped>
.plat-style {
  /deep/.el-form-item__content {
    line-height: 20px;
    padding-top: 10px;
  }
}
/deep/.el-dialog__footer {
  padding-bottom: 30px;
}
/deep/.el-dialog__body {
  padding: 30px 40px;
  padding-bottom: 0px;
}
</style>
